import { c as _c } from "react/compiler-runtime";
import { BackupPolicyType } from '@repo/api-gw-sdk';
import { Tag } from '@/components/tag';
import { isAzureEntraIdPolicyType, isGoogleWorkspacePolicyType, isMicrosoft365PolicyType, isPitrPolicyType, isStandardPolicyType } from './backupPoliciesTypes';
export const BackupPolicyTypeTag = t0 => {
  const $ = _c(2);
  const {
    policyType: t1
  } = t0;
  const policyType = t1 === undefined ? BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD : t1;
  if (policyType === BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED) {
    return null;
  }
  const content = isPitrPolicyType(policyType) ? "PiTR" : policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ? "High-frequency" : isGoogleWorkspacePolicyType(policyType) ? "Google Workspace" : isMicrosoft365PolicyType(policyType) ? "Microsoft 365" : isAzureEntraIdPolicyType(policyType) ? "Entra ID" : isStandardPolicyType(policyType) ? "Standard" : "Unknown";
  let t2;
  if ($[0] !== content) {
    t2 = content && <Tag noWrap={true} content={content} variant="secondary" />;
    $[0] = content;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};